import * as React from 'react'
import type { PasswordStrength } from 'types/business'
import { getPasswordStrengthMinimumCharsInWords } from '@disco/utils/password'
type Props = {
  className?: string
  omitMinimumChars: boolean
  passwordStrength?: PasswordStrength
}

const PasswordRequirementsList = ({
  className,
  omitMinimumChars,
  passwordStrength = 'standard',
}: Props): React.ReactElement<'ul'> => (
  <ul className={className}>
    {!omitMinimumChars && (
      <li>
        At least {getPasswordStrengthMinimumCharsInWords(passwordStrength)}{' '}
        characters
      </li>
    )}
    <li>At least one number</li>
    {passwordStrength === 'standard' ? (
      <li>
        Optionally use uppercase and lowercase characters, special characters
        and numbers.
      </li>
    ) : (
      <>
        <li>At least one uppercase character</li>
        <li>At least one lowercase character</li>
        <li>At least one special character</li>
      </>
    )}
  </ul>
)

export default PasswordRequirementsList
